import React from "react";
import { PropTypes } from "prop-types";
import { Avatar } from "antd";
import {
  PhoneOutlined,
  EnvironmentOutlined,
  PrinterOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";

const { Title, Text } = Typography;
const BranchListItem = (props) => {
  let history = useHistory();
  const { branch } = props;
  const intl = useIntl();

  let address = null;
  if (branch.address && branch.address.city) {
    address = branch.address.city;
  }
  if (branch.address && branch.address.street) {
    if (address) {
      address = address + ", " + branch.address.street;
    } else {
      address = branch.address.street;
    }
  }
  if (branch.address && branch.address.house_number) {
    if (address) {
      address = address + ", " + branch.address.house_number;
    } else {
      address = branch.address.house_number;
    }
  }
  const items = [
    {
      key: 1,
      content: branch.phone_number
        ? branch.phone_number
        : intl.formatMessage({
            id: "app.users.undefined",
          }),
      icon: <PhoneOutlined />,
    },
    {
      key: 2,
      content: branch.mobile_number
        ? branch.mobile_number
        : intl.formatMessage({
            id: "app.users.undefined",
          }),
      icon: <PrinterOutlined />,
    },
    {
      key: 3,
      content: branch.email
        ? branch.email
        : intl.formatMessage({
            id: "app.users.undefined",
          }),
      icon: <GlobalOutlined />,
    },
    {
      key: 4,
      content: address
        ? address
        : intl.formatMessage({
            id: "app.users.undefined",
          }),
      icon: <EnvironmentOutlined />,
    },
  ];

  const onBranchClick = () => {
    const url = "/branches/" + branch.id;
    history.push(url);
  };
  const renderFields = () => {
    return items.map((item, i) => {
      return (
        <AnimationChildWrapper key={item.key} itemKey={item.key}>
          <div className="fieldContainer">
            <Avatar size="large" icon={item.icon} />
            <Text>{item.content}</Text>
          </div>
        </AnimationChildWrapper>
      );
    });
  };

  return (
    <div className="listItem" onClick={onBranchClick}>
      <Title level={3}>{branch.name}</Title>
      <ChildrenAnimationWrapper>
        <div>{renderFields()}</div>
      </ChildrenAnimationWrapper>
    </div>
  );
};

BranchListItem.propTypes = {
  itemKey: PropTypes.number,
  children: PropTypes.object,
};

export default BranchListItem;
